import Link from "next/link";
import React from "react";
import SubArrow from "./svgs/sub-arrow.svg";

const SubArrowLink = ({ href, text, className }: { href: string; text: string; className?: string }) => {
	return (
		<Link href={href} className={`mt-1.5 flex items-center gap-2 pl-[3.875rem] ${className ? className : ""}`}>
			<SubArrow className="mb-1 w-3 stroke-[2px] lg:w-4" />
			<span className="link-underline">{text}</span>
		</Link>
	);
};

export default SubArrowLink;
